import { useContext } from 'react'
import MessageContext from '../contexts/MessageProvider'

const useMessage = () => {
    return useContext(MessageContext)
}

export default useMessage
